import { createI18n } from 'vue-i18n';
import {
  applyBrandingToText,
  getBrandingConfigFromWindow,
} from 'shared/helpers/brandingText';

export const brandingI18nOptions = {
  postTranslation: translated => {
    if (typeof translated !== 'string') return translated;
    return applyBrandingToText(translated, getBrandingConfigFromWindow());
  },
};

export const createBrandedI18n = ({
  locale = 'en',
  messages,
  legacy = false,
}) =>
  createI18n({
    legacy,
    locale,
    messages,
    ...brandingI18nOptions,
  });
